<template>
  <div class="main" id="main">
    <router-view />
  </div>
</template>
<style scoped>
.main {
  height: 100%;
  width: 100%;
  position: relative;
}

</style>
<script>
import https from "@/https.js";
import MyHeader from "@/components/header.vue";
export default {
  components: {
    MyHeader: MyHeader,
  },
  data() {
    return {
      
    };
  },
  created() {
    //this.init();
  },
  methods: {
    back() {},
  },
};
</script>
